import { useDispatch } from 'react-redux';
import { useCallback } from 'react';

import { UserMsg } from '../user.actions';

/**
 *
 */
export function useSignoutCallback() {
    const dispatch = useDispatch();
    return useCallback(
        (e) => {
            e.preventDefault();
            dispatch(UserMsg('User.SignOut'));
        },
        [dispatch],
    );
}
